//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestWorksGroupInclusionModeEditor from './RequestWorksGroupInclusionModeEditor.vue'

export default {
  name: 'RequestWorkPackageGroupInclusionMode',
  props: {
    workPackage: {
      type: Object,
      default () {
        return {}
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    isAdditionalDeparture: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dialogHeaders: {
        pause: `Продолжить добавление работ в составе комплекса "${this.workPackage.name}"`,
        resume: `Продолжить добавление работ в составе комплекса "${this.workPackage.name}"`,
        edit: `Редактировать режим добавления работ в составе комплекса "${this.workPackage.name}"`
      }
    }
  },
  methods: {
    onEdit: function (type) {
      const dialog = this.$d.dialog(this).show({
        contentComponent: RequestWorksGroupInclusionModeEditor,
        contentWidth: 1200,
        contentProps: {
          workPackages: [this.workPackage],
          request: this.request,
          type: type,
          isAdditionalDeparture: this.isAdditionalDeparture
        },
        componentHandlers: {
          select: (data) => {
            this.$emit('update-work-package', data.workPackages[0])
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        },
        headerLabel: this.dialogHeaders[type],
        persistent: true,
        maximized: false,
        width: '500px'
      })
    }
  }
}
